<template>
    <div class="modal-body">
        <slot></slot>
    </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
    name: "ModalBody",
});
</script>

<style scoped>
.modal-body {
    padding: 15px 0;
}
</style>